import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AdminDataProvider, useAdminData } from './contexts/AdminDataContext';
import { AdminShell } from './components/admin/AdminShell';
import { PublicSite } from './pages/PublicSite';
import { AdminLogin } from './pages/admin/AdminLogin';
import { Overview } from './pages/admin/Overview';
import { Cases } from './pages/admin/Cases';
import { CaseNew } from './pages/admin/CaseNew';
import { CaseDetail } from './pages/admin/CaseDetail';
import { Customers } from './pages/admin/Customers';
import { CustomerDetail } from './pages/admin/CustomerDetail';
import { Settings } from './pages/admin/Settings';
function RequireAdmin({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    loggedIn
  } = useAdminData();
  if (!loggedIn) return <Navigate to="/admin/login" replace data-id="element-0" data-mp="28tmfb3zlmcxr" />;
  return <>{children}</>;
}
export function App() {
  return <AdminDataProvider data-id="element-1" data-mp="23w4ek0vqj40u">
      <BrowserRouter data-id="element-2" data-mp="23utby4e102bb">
        <Routes data-id="element-3" data-mp="23t8h0dnsuhcx">
          <Route path="/" element={<PublicSite data-id="element-5" data-mp="3ikqzm1my986s" />} data-id="element-4" data-mp="3ijxokogyjwiu" />
          <Route path="/admin/login" element={<AdminLogin data-id="element-7" data-mp="3ii4qvyobommz" />} data-id="element-6" data-mp="3ijfwm41bw4gq" />
          <Route path="/admin" element={<RequireAdmin data-id="element-9" data-mp="3mj6jvxrnc2gi">
                <AdminShell data-id="element-10" data-mp="3rbrbcsn2y3gv" />
              </RequireAdmin>} data-id="element-8" data-mp="3ml12v6jcxkhy">
            <Route index element={<Overview data-id="element-12" data-mp="67z9oh5w26u" />} data-id="element-11" data-mp="5yh2n2cyzbp" />
            <Route path="sager" element={<Cases data-id="element-14" data-mp="82ovg3doih9" />} data-id="element-13" data-mp="4n7u7q58zd7" />
            <Route path="sager/ny" element={<CaseNew data-id="element-16" data-mp="2zm4xcjfp5b1a" />} data-id="element-15" data-mp="2zld2xbxu5jcl" />
            <Route path="sager/:caseId" element={<CaseDetail data-id="element-18" data-mp="33mf3bw3ho1g5" />} data-id="element-17" data-mp="2zmwguvw0rib7" />
            <Route path="kunder" element={<Customers data-id="element-20" data-mp="33mymth8sexwa" />} data-id="element-19" data-mp="33nq73vwxp979" />
            <Route path="kunder/:customerId" element={<CustomerDetail data-id="element-22" data-mp="38kqb81a841vq" />} data-id="element-21" data-mp="38lrnua6w0wfk" />
            <Route path="indstillinger" element={<Settings data-id="element-24" data-mp="3dkl60fx4dbm2" />} data-id="element-23" data-mp="38kgnylgkc8tq" />
          </Route>
          <Route path="*" element={<Navigate to="/" replace data-id="element-26" data-mp="3dirvgpjdy78s" />} data-id="element-25" data-mp="3dmfqxu8e53q5" />
        </Routes>
      </BrowserRouter>
    </AdminDataProvider>;
}